module.exports = ".center-logo {\n    padding-bottom: 2px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/navbar/navbar.component.css
// module id = ./src/app/navbar/navbar.component.css
// module chunks = main